import { Pipe } from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { PrefixedTranslatePipe } from './prefixed-translate.pipe'

@Pipe({
  name: 'batchJobType',
  pure: false
})
export class BatchJobTypePipe extends PrefixedTranslatePipe {

  constructor(translatePipe: TranslatePipe) {
    super(translatePipe, 'BATCH_JOB_TYPE.')
  }

}
